__turbopack_context__.v({
  "fixed-layout": "CoreTable-module-scss-module__qcnPoq__fixed-layout",
  "is-style-stripes": "CoreTable-module-scss-module__qcnPoq__is-style-stripes",
  "table": "CoreTable-module-scss-module__qcnPoq__table",
});
